import { type FC } from "react"

import AspectRatio from "./AspectRatio"

export const BunnyPlayer: FC<{ videoId: string; className?: string }> = ({ videoId, className }) => (
	<AspectRatio width={{ unit: "percent", value: 100 }} aspectRatio={16 / 9} className={className}>
		<iframe
			src={`/api/videos/iframe/bunny/${videoId}`}
			allowFullScreen
			allow="accelerometer; gyroscope; encrypted-media; picture-in-picture;"
			className="h-full w-full border-none"
		/>
	</AspectRatio>
)

export const YoutubePlayer: FC<{ videoId: string; className?: string }> = ({ videoId, className }) => (
	<AspectRatio width={{ unit: "percent", value: 100 }} aspectRatio={16 / 9} className={className}>
		<iframe
			src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1`}
			allowFullScreen
			allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
			referrerPolicy="strict-origin-when-cross-origin"
			className="h-full w-full border-none"
		/>
	</AspectRatio>
)

export const VimeoPlayer: FC<{ videoId: string; className?: string }> = ({ videoId, className }) => (
	<AspectRatio width={{ unit: "percent", value: 100 }} aspectRatio={16 / 9} className={className}>
		<iframe
			src={`https://player.vimeo.com/video/${videoId}?title=0&byline=0&portrait=0&badge=0&autopause=0&autoplay=1`}
			allowFullScreen
			allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
			referrerPolicy="strict-origin-when-cross-origin"
			className="h-full w-full border-none"
		/>
	</AspectRatio>
)

export const LoomPlayer: FC<{ videoId: string; className?: string }> = ({ videoId, className }) => (
	<AspectRatio width={{ unit: "percent", value: 100 }} aspectRatio={16 / 9} className={className}>
		<iframe
			src={`https://www.loom.com/embed/${videoId}?hideEmbedTopBar=true&hide_title=true&hide_owner=true`}
			allowFullScreen
			className="h-full w-full border-none"
		/>
	</AspectRatio>
)
